// File: `app/javascript/controllers/product_module/car.js`
import $ from 'jquery';
import {extractTimeValues, setupOfficeHelper} from "./office_helper";
import {withElementBlock} from "../blockUI_controller";

export function initCar(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        setSessionVar,
        get_modalities,
        get_contract,
        get_tariffs,
        // NOTA: withElementBlock se importa directo (arriba) y NO se espera en deps;
        // si se incluyera aquí, el destructuring lo pisaría con undefined (preferences_controller
        // no lo pasa) y daría "withElementBlock is not a function".
        flatpickr,
        date_disabled,
        flatpick_lang,
        I18n,
        locale,
        verify_season,
        categories_details,
        year,
        month,
        day,
        hour,
        minutes,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    let car_to, car_destino, car_recogida, car_entrega;
    car_to = $('#car_to');
    let car_select_collect = $('#car_collect_place');
    let car_select_delivery = $('#car_delivery_place');
    let car_date_collect = $('#car_date_collect');
    let car_date_delivery = $('#car_date_delivery');
    let car_time_collect = $('#car_time_collect');
    let car_time_delivery = $('#car_time_delivery');
    let car_collect = car_select_collect.prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
    });
    let car_delivery = car_select_delivery.prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
    });
    let car_category = $('#car_category').prop('disabled', true).select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category')
    });
    let drivers = $('#drivers').select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_drivers')
    });

    let has_drivers = $('#has_drivers');
    let supplement_insurance = $('#supplement_insurance');

    /* Chofer Adicional */
    if (create_array_for_product('drivers', '', 'show') === undefined) {
        create_array_for_product('drivers', 0);
    }

    has_drivers.on('change', function (e) {
        let driver_count = $('#drivers_count');
        if (e.target.checked) {
            driver_count.removeClass('ocultar');
            create_array_for_product('drivers', 1);
            drivers.select2({
                theme: "bootstrap", placeholder: I18n.t('global.main.form.select_drivers'), data: [{
                    id: 1, text: '1'
                }, {
                    id: 2, text: '2'
                }]
            }).on('change', function (e) {
                create_array_for_product('drivers', e.target.value);
                setSessionVar('drivers', e.target.value, 'add', false).then();
            })
        } else {
            drivers.val(null).trigger('change');
            driver_count.addClass('ocultar');
            create_array_for_product('drivers', 0);
            setSessionVar('drivers', '0', 'add', false).then();
        }
    })
    /* Chofer Adicional FINNN */

    /* Suplemento de Edad */
    if (create_array_for_product('supplement_insurance', '', 'show') === undefined) {
        create_array_for_product('supplement_insurance', 0);
    }
    supplement_insurance.on('change', function (e) {
        if (e.target.checked) {
            create_array_for_product('supplement_insurance', 1);
        } else {
            create_array_for_product('supplement_insurance', 0);
        }
    })
    /* Suplemento de Edad FINNN */

    /* Car new product */
    car_to.select2({
        theme: "bootstrap", placeholder: I18n.t('global.main.form.select_destiny'), ajax: {
            url: `${location.origin}/${locale.locale}/destination`,
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;

                data.rows.map((elem, key) => {
                    result.push({
                        id: elem.code + '|' + elem.id, text: elem.name
                    })
                })

                if (data.total > 10) {
                    if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                        return {
                            results: result, "pagination": {
                                "more": true
                            }
                        }
                    } else {
                        return {
                            results: result, "pagination": {
                                "more": false
                            }
                        }
                    }
                } else {
                    return {
                        results: result, "pagination": {
                            "more": false
                        }
                    }
                }
            }
        }
    }).on('change', function (e) {
        //LIMPIAR SELECT2
        car_collect.empty();
        car_delivery.empty();
        car_category.empty();
        //FIN DE LIMPIEZA

        let split = e.target.value.split('|');
        car_destino = split[0]
        let destino_id = split[1]
        create_array_for_product('product_type', form_type_send[0].value);
        create_array_for_product('destination', car_destino);
        create_array_for_product('amount', 1);
        create_array_for_product('pax', 1);
        create_array_for_product('destination_id', e.target.value.split("|")[1]);
        create_array_for_product('text_destination', $(e.target).select2('data')[0].text);

        // FIX (2026-08-10): se RESTAURA el select2 perezoso original (AJAX al abrir/buscar).
        // La precarga con data: rompía el flujo: el test y el flujo real dependen de que al
        // abrir/seleccionar la oficina de entrega se disparen las peticiones por detrás.
        // El bloqueo + aviso de error se maneja en los handlers onDeliveryChange/onCollectChange.
        car_delivery.select2({
            theme: "bootstrap",
            language: "es",
            placeholder: I18n.t('global.main.form.select_office'),
            ajax: {
                url: `${location.origin}/${locale.locale}/office_by_destination`,
                data: function (params) {
                    return {
                        search: params.term, page: params.page || 1, destination: destino_id,
                        type: form_type_send[0].dataset.type
                    }
                },
                type: "GET",
                processResults: function (data, params) {
                    return { results: buildOfficeResults(data) };
                }
            }
        }).prop("disabled", false).off('change').on('change', onDeliveryChange);

        car_collect.select2({
            theme: "bootstrap",
            language: "es",
            placeholder: I18n.t('global.main.form.select_office'),
            ajax: {
                url: `${location.origin}/${locale.locale}/office_by_destination`,
                data: function (params) {
                    return {
                        search: params.term, page: params.page || 1, destination: destino_id,
                        type: form_type_send[0].dataset.type
                    }
                },
                type: "GET",
                processResults: function (data, params) {
                    return { results: buildOfficeResults(data) };
                }
            }
        }).prop("disabled", false).off('change').on('change', onCollectChange);
    });

    // FIX (2026-08-10): mapeo de oficinas extraído de processResults (precarga del destino).
    function buildOfficeResults(data) {
        let result = [];
        (data.offices || []).map((elem, key) => {
            let aux = {
                text: elem.dealer_name, children: []
            };

            if (elem.offices.length > 0) {
                elem.offices.map((child, number) => {
                    if (child.active) {
                        aux.children.push({
                            id: child.code + '-dealer:' + elem.dealer_code + '-dealer_name:' + elem.dealer_name.replace(/-/g, '_') + '-full_time:' + child.full_time + '-open_time:' + child.open_time + '-close_time:' + child.close_time,
                            text: child.name
                        });
                    }
                })

                result.push(aux);
            }
        })

        if (result.length === 0) {
            result.push({
                text: "No hay datos para mostrar", children: []
            });
        }

        return result;
    }

    // FIX (2026-08-10): handlers con nombre para re-engancharlos tras la precarga.
    // Entrega: bloquea mientras se pre-calienta contrato+tarifa (solo si ya hay dealer).
    function onDeliveryChange(e) {
        car_entrega = e.target.value;
        car_entrega = car_entrega.split('-');

        create_array_for_product('drop_off_place', car_entrega[0]);
        create_array_for_product('delivery_place_text', $(e.target).select2('data')[0].text);

        setupOfficeHelper(car_delivery, e.target.value, I18n);

        const { openTime, closeTime } = extractTimeValues(e.target.value);
        create_array_for_product('open_time', openTime);
        create_array_for_product('close_time', closeTime);

        /*let helper_delivery = $(car_delivery[0].parentNode).find('.helper-text');
        let tootltip_button_delivery = $(car_delivery[0].parentNode).find('.tooltip-button');
        let text_helper = '';
        let full_time = car_entrega[3].split('full_time:')[1];
        if (full_time === "false") {
            let from = car_entrega[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(car_entrega[5].split("close_time:")[1]) - 12) + ":00pm";
            text_helper = I18n.t('global.main.form.work_by_hours', {from: from, to: to});
        } else {
            text_helper = I18n.t('global.main.form.work_all_day');
        }
        helper_delivery.text(text_helper);
        tootltip_button_delivery[0].classList.remove('hide-tooltip');*/

        $(`#car_date_collect`).prop('disabled', true);
        $(`#car_time_collect`).prop('disabled', true);

        // FIX (2026-08-10): bloquear mientras se pre-calienta contrato+tarifa (idempotente,
        // solo rellena product_array). Solo si ya hay dealer seleccionado en recogida.
        const dealer_actual = create_array_for_product('dealer', '', 'show');
        if (dealer_actual !== undefined) {
            withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'), new Promise((resolve) => {
                // get_contract/get_tariffs SIN box_block: el withElementBlock ya cubre el overlay
                // y evita el unblock prematuro del helper; el helper ya avisa con toastr en error.
                get_contract(null, dealer_actual).then(gcontract => {
                    if (!gcontract.next) {
                        resolve();
                        return;
                    }
                    get_tariffs(null).then(() => {
                        resolve();
                    });
                });
            }), { timeout: 30000 });
        }
    }

    // Recogida: bloquea el formulario hasta que terminen TODAS las llamadas por detrás
    // (modalidades + contrato + tarifa). withElementBlock desbloquea en éxito/error/timeout.
    function onCollectChange(e) {
        car_recogida = e.target.value;
        car_recogida = car_recogida.split('-');

        let car_time_collect = $('#car_time_collect');
        car_time_collect.prop('readonly', true);

        create_array_for_product('pick_up_place', car_recogida[0]);
        create_array_for_product('dealer', car_recogida[1].split('dealer:')[1]);
        create_array_for_product('dealer_name', car_recogida[2].split('dealer_name:')[1]);
        create_array_for_product('collect_place_text', $(e.target).select2('data')[0].text);

        // Usar método genérico para recogida
        setupOfficeHelper(car_collect, e.target.value, I18n);

        // Extraer horas
        const { openTime, closeTime } = extractTimeValues(e.target.value);
        create_array_for_product('open_time_collect', openTime);
        create_array_for_product('close_time_collect', closeTime);

        /*let helper = $(car_collect[0].parentNode).find('.helper-text');
        let tootltip_button = $(car_collect[0].parentNode).find('.tooltip-button');
        let text_helper = '';
        let full_time_collect = car_recogida[3].split('full_time:')[1];
        if (full_time_collect === "false") {
            let from = car_recogida[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(car_recogida[5].split("close_time:")[1]) - 12) + ":00pm";
            create_array_for_product('open_time_collect', (car_recogida[4].split('open_time:')[1].length === 1 ? `0${car_recogida[4].split('open_time:')[1]}` : car_recogida[4].split('open_time:')[1]));
            create_array_for_product('close_time_collect', (car_recogida[5].split('close_time:')[1].length === 1 ? `0${car_recogida[5].split('close_time:')[1]}` : car_recogida[5].split('close_time:')[1]));
            text_helper = I18n.t('global.main.form.work_by_hours', { from: from, to: to });
        } else {
            text_helper = I18n.t('global.main.form.work_all_day');
        }
        helper.text(text_helper);
        tootltip_button[0].classList.remove('hide-tooltip');*/

        const dealer_collect = car_recogida[1].split('dealer:')[1];

        // Cargar modalidades disponibles (envuelto en Promesa para el withElementBlock)
        const loadModalities = () => new Promise((resolve) => {
            $.ajax({
                url: `${location.origin}/${sessionStorage.getItem('locale')}/load_modalities`,
                data: {
                    product_type: create_array_for_product('product_type', '', 'show'),
                    dealer: dealer_collect
                },
                type: 'GET',
                dataType: 'json',
                timeout: 30000,
                success: function (data) {
                    if (data.success) {
                        let text_car_category = $('#text_car_category');
                        let helper = $(text_car_category[0].parentElement).find('.helper-text');

                        if (parseInt(data.count) > 1) {
                            let data_result = [{ id: 0, text: I18n.t('global.main.form.select_modality') }];
                            text_car_category[0].classList.remove('ocultar');
                            helper[0].innerHTML = "";

                            (data.data || []).forEach(index => {
                                let text_modality_show = index.name.split(" ");
                                text_modality_show.shift();
                                text_modality_show = text_modality_show.join(" ");
                                data_result.push({
                                    id: `${index.code}|${index.name}|${index.id}`,
                                    text: text_modality_show
                                });
                            });

                            car_category.select2({
                                theme: "bootstrap",
                                placeholder: I18n.t('global.main.form.select_modality'),
                                data: data_result
                            }).prop("disabled", false).on('change', function (e) {
                                let modality_selected = e.target.value.split("|");
                                create_array_for_product('modality_code', modality_selected[0]);
                                create_array_for_product('modalities_name', modality_selected[1]);
                                create_array_for_product('has_modality', true);
                            });
                        } else {
                            text_car_category[0].classList.add('ocultar');
                            create_array_for_product('modality_code', data.data[0].code);
                            create_array_for_product('modalities_name', data.data[0].name);
                            create_array_for_product('text_category', $(e.target).select2('data')[0].text);
                            create_array_for_product('category', data.product[0].code);

                            setSessionVar('day_delay_rent', data.product[0].reservation_time, 'add', false).then();
                            setSessionVar('day_min_rent', data.product[0].min_length_reservation, 'add', false).then();
                            setSessionVar('day_max_rent', data.product[0].max_length_reservation, 'add', false).then();
                            setSessionVar('use_same_hours', data.product[0].same_hours, 'add', false).then();

                            if (!car_date_collect[0].value.isEmpty() && data.product[0].same_hours === false) {
                                car_time_delivery.prop('disabled', false);
                                car_time_delivery[0].value = '';
                                create_array_for_product('car_time_delivery', '', 'delete');
                            } else if (!car_date_collect[0].value.isEmpty() && data.product[0].same_hours === true) {
                                car_time_delivery.prop('disabled', true);
                                car_time_delivery[0].value = car_time_collect[0].value;
                                create_array_for_product('car_time_delivery', car_time_collect[0].value);
                            }

                            car_date_collect.prop('disabled', false);
                            car_time_collect.prop('disabled', true);
                            car_time_collect.prop('readonly', true);

                            flatpickr("#car_date_collect", {
                                altInput: true,
                                altFormat: "d-m-Y",
                                dateFormat: "Y-m-d",
                                disable: date_disabled,
                                disableMobile: "true",
                                minDate: new Date().fp_incr(parseInt(data.product[0].reservation_time) || 0),
                                maxDate: new Date().fp_incr(180),
                                locale: flatpick_lang
                            });
                        }
                    } else {
                        toastr.warning(data.msg, 'Warning');
                    }
                    resolve();
                },
                error: function () {
                    resolve();
                }
            });
        });

        // Contrato y tarifas SIN box_block: el withElementBlock ya cubre el overlay y evita
        // el unblock prematuro del helper; los helpers ya avisan con toastr en error.
        const contractTariff = get_contract(null, dealer_collect).then(gcontract => {
            if (!gcontract.next) {
                return;
            }
            // return la cadena interna: el Promise.all espera hasta que TERMINE la tarifa.
            return get_tariffs(null).then(gtariffs => {
                if (!gtariffs.next) {
                    // el helper ya avisó del error
                }
            });
        });

        // Bloquear hasta que terminen TODAS las llamadas por detrás.
        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
            Promise.all([loadModalities(), contractTariff]),
            { timeout: 30000 });

        let full_time_val = car_recogida[3].split('full_time:')[1];
        create_array_for_product('full_time', full_time_val);
    }

    car_date_collect.on('change', (e) => {
        car_time_collect.prop('disabled', false);
        car_time_collect.prop('readonly', false);

        //ESTABLECER HORAS SELECCIONABLES EN DEPENDENCIA DEL DIA QUE SE SELECCIONE
        let min_time = create_array_for_product('open_time_collect', '', 'show');
        let max_time = create_array_for_product('close_time_collect', '', 'show');
        let selected_date = e.target.value.split('-');
        let especial_behavior = false;
        if (`${year}-${month}-${day}` === e.target.value || (year === parseInt(selected_date[0]) && parseInt(month) === parseInt(selected_date[1]) && (parseInt(selected_date[2]) - day) === 1)) {
            especial_behavior = true;
            min_time = `${hour}:${minutes}`;
            max_time = "23:55";
        }

        if (create_array_for_product('full_time', '', 'show') === "false") {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                /*minTime: min_time,
                maxTime: max_time,*/
                minTime: `${min_time}:00`,
                maxTime: `${max_time}:00`
            })
        } else {
            if (especial_behavior) {
                flatpickr(".timepicker", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    defaultDate: min_time,
                    altFormat: "H:i",
                    time_24hr: true,
                    locale: flatpick_lang,
                    disableMobile: "true",
                    minTime: min_time,
                    maxTime: max_time,
                })
            } else {
                flatpickr(".timepicker", {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: "H:i",
                    defaultDate: min_time,
                    altFormat: "H:i",
                    time_24hr: true,
                    locale: flatpick_lang,
                    disableMobile: "true",
                })
            }
        }
        //FIN DE HORAS

        //VERIFICAR TEMPORADA
        verify_season(e.target.value).then(vs => {
            let max_date = 0;
            let min_date = 0;

            // FIX (2026-08-11): si set_session_var fue redirigido a /offline.html (o falló),
            // day_min_rent/day_max_rent no están en sessionStorage → parseInt(null) = NaN →
            // new Date().fp_incr(NaN) es Invalid Date → flatpickr lanza "Invalid date provided".
            if (vs.length > 0) {
                max_date = parseInt(vs[0].max) + 1;
                min_date = parseInt(vs[0].min) + 1;
            } else {
                max_date = parseInt(sessionStorage.getItem('day_max_rent')) + 1;
                min_date = parseInt(sessionStorage.getItem('day_min_rent')) + 1;
            }
            if (Number.isNaN(min_date)) { min_date = 0; }
            if (Number.isNaN(max_date) || max_date < min_date) { max_date = 180; }
            car_date_delivery.prop('disabled', false);
            flatpickr("#car_date_delivery", {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disableMobile: "true",
                disable: date_disabled,
                minDate: new Date(e.target.value).fp_incr(min_date),
                maxDate: new Date(e.target.value).fp_incr(max_date),
                locale: flatpick_lang
            });

            if (sessionStorage.getItem('use_same_hours') !== 'true') {
                car_time_delivery.prop('disabled', false);
            }

        });
    })
    car_time_collect.on('change', (e) => {
        if (sessionStorage.getItem('use_same_hours') === 'true') {
            car_time_delivery[0].value = e.target.value;
            create_array_for_product('car_time_delivery', e.target.value);
        }
    })
    /* Car new product FINN */
}


/* Antes de dividir */
/*
let car_to, car_destino, car_recogida, car_entrega;
car_to = $('#car_to');
let car_select_collect = $('#car_collect_place');
let car_select_delivery = $('#car_delivery_place');
let car_collect = car_select_collect.prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
});
let car_delivery = car_select_delivery.prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_office')
});
let car_category = $('#car_category').prop('disabled', true).select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category')
});
let drivers = $('#drivers').select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_drivers')
});

let has_drivers = $('#has_drivers');
let supplement_insurance = $('#supplement_insurance');

/!* Chofer Adicional *!/
if (create_array_for_product('drivers', '', 'show') === undefined) {
    create_array_for_product('drivers', 0);
}

has_drivers.on('change', function (e) {
    let driver_count = $('#drivers_count');
    if (e.target.checked) {
        driver_count.removeClass('ocultar');
        create_array_for_product('drivers', 1);
        drivers.select2({
            theme: "bootstrap", placeholder: I18n.t('global.main.form.select_drivers'), data: [{
                id: 1, text: '1'
            }, {
                id: 2, text: '2'
            }]
        }).on('change', function (e) {
            create_array_for_product('drivers', e.target.value);
            setSessionVar('drivers', e.target.value, 'add', false).then();
        })
    } else {
        drivers.val(null).trigger('change');
        driver_count.addClass('ocultar');
        create_array_for_product('drivers', 0);
        setSessionVar('drivers', '0', 'add', false).then();
    }
})
/!* Chofer Adicional FINNN *!/

/!* Suplemento de Edad *!/
if (create_array_for_product('supplement_insurance', '', 'show') === undefined) {
    create_array_for_product('supplement_insurance', 0);
}
supplement_insurance.on('change', function (e) {
    if (e.target.checked) {
        create_array_for_product('supplement_insurance', 1);
        // setSessionVar('supplement_insurance','1','add',false).then();
    } else {
        create_array_for_product('supplement_insurance', 0);
        // setSessionVar('supplement_insurance','0','add',false).then();
    }
})
/!* Suplemento de Edad FINNN *!/

/!* Car new product *!/
car_to.select2({
    theme: "bootstrap", placeholder: I18n.t('global.main.form.select_destiny'), ajax: {
        url: `${location.origin}/${locale.locale}/destination`,
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                // form_type: form_type_send[0].dataset.type,
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }
        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id, text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result, "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result, "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result, "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    //LIMPIAR SELECT2
    car_collect.empty();
    car_delivery.empty();
    car_category.empty();
    //FIN DE LIMPIEZA

    let split = e.target.value.split('|');
    car_destino = split[0]
    let destino_id = split[1]
    create_array_for_product('product_type', form_type_send[0].value);
    create_array_for_product('destination', car_destino);
    create_array_for_product('amount', 1);
    create_array_for_product('pax', 1);
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('text_destination', $(e.target).select2('data')[0].text);

    car_delivery.select2({
        theme: "bootstrap",
        language: "es",
        placeholder: I18n.t('global.main.form.select_office'),
        ajax: {
            url: `${location.origin}/${locale.locale}/office_by_destination`,
            data: function (params) {
                return {
                    /!*search: params.term, page: params.page || 1,
                    type: form_type_send[0].dataset.type*!/
                    search: params.term, page: params.page || 1, destination: destino_id,
                    type: form_type_send[0].dataset.type
                }
            },
            type: "GET",
            processResults: function (data, params) {
                let result = [];
                data.offices.map((elem, key) => {
                    let aux = {
                        text: elem.dealer_name, children: []
                    };

                    if (elem.offices.length > 0) {
                        elem.offices.map((child, number) => {
                            if (child.active) {
                                aux.children.push({
                                    id: child.code + '-dealer:' + elem.dealer_code + '-dealer_name:' + elem.dealer_name.replace(/-/g, '_') + '-full_time:' + child.full_time + '-open_time:' + child.open_time + '-close_time:' + child.close_time,
                                    text: child.name
                                });
                            }
                        })

                        result.push(aux);
                    }
                })

                if (result.length === 0) {
                    result.push({
                        text: "No hay datos para mostrar", children: []
                    });
                }

                return {
                    results: result
                }
            }
        }
    }).prop("disabled", false).on('change', function (e) {
        car_entrega = e.target.value;
        car_entrega = car_entrega.split('-');

        create_array_for_product('drop_off_place', car_entrega[0]);
        create_array_for_product('delivery_place_text', $(e.target).select2('data')[0].text);

        let helper_delivery = $(car_delivery[0].parentNode).find('.helper-text');
        let tootltip_button_delivery = $(car_delivery[0].parentNode).find('.tooltip-button');
        let text_helper = '';
        let full_time = car_entrega[3].split('full_time:')[1];
        if (full_time === "false") {
            let from = car_entrega[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(car_entrega[5].split("close_time:")[1]) - 12) + ":00pm";
            text_helper = I18n.t('global.main.form.work_by_hours', {from: from, to: to});
        } else {
            text_helper = I18n.t('global.main.form.work_all_day');

        }
        helper_delivery.text(text_helper);
        tootltip_button_delivery[0].classList.remove('hide-tooltip');

        $(`#car_date_collect`).prop('disabled', true);
        $(`#car_time_collect`).prop('disabled', true);
    });

    car_collect.select2({
        theme: "bootstrap",
        language: "es",
        placeholder: I18n.t('global.main.form.select_office'),
        ajax: {
            url: `${location.origin}/${locale.locale}/office_by_destination`,
            data: function (params) {
                return {
                    search: params.term, page: params.page || 1, destination: destino_id,
                    type: form_type_send[0].dataset.type
                }
            },
            type: "GET",
            processResults: function (data, params) {
                let result = [];
                data.offices.map((elem, key) => {
                    let aux = {
                        text: elem.dealer_name, children: []
                    };

                    if (elem.offices.length > 0) {
                        elem.offices.map((child, number) => {
                            if (child.active) {
                                aux.children.push({
                                    id: child.code + '-dealer:' + elem.dealer_code + '-dealer_name:' + elem.dealer_name.replace(/-/g, '_') + '-full_time:' + child.full_time + '-open_time:' + child.open_time + '-close_time:' + child.close_time,
                                    text: child.name
                                });
                            }
                        })

                        result.push(aux);
                    }
                })

                if (result.length === 0) {
                    result.push({
                        text: "No hay datos para mostrar", children: []
                    });
                }

                return {
                    results: result
                }
            }
        }
    }).prop("disabled", false).on('change', function (e) {
        car_recogida = e.target.value;
        car_recogida = car_recogida.split('-');

        let car_time_collect = $('#car_time_collect');
        car_time_collect.prop('readonly', true);

        create_array_for_product('pick_up_place', car_recogida[0]);
        create_array_for_product('dealer', car_recogida[1].split('dealer:')[1]);
        create_array_for_product('dealer_name', car_recogida[2].split('dealer_name:')[1]);
        create_array_for_product('collect_place_text', $(e.target).select2('data')[0].text);

        let helper = $(car_collect[0].parentNode).find('.helper-text');
        let tootltip_button = $(car_collect[0].parentNode).find('.tooltip-button');
        /!*let tootltip_button = $('#car_collect_place option[value="' + car_recogida.join('-') + '"]')[0].parentNode.parentNode.querySelector('.tooltip-button');*!/
        let text_helper = '';

        //ESTO ES TEMPORAL
        car_category.select2({
            theme: "bootstrap", placeholder: I18n.t('global.main.form.select_category'), ajax: {
                url: `${location.origin}/${locale.locale}/service_by_dealer`,
                data: function (params) {
                    return {
                        // form_type: form_type_send[0].dataset.type,
                        form_type: form_type_send[0].value,
                        search: params.term,
                        page: params.page || 1,
                        dealer: car_recogida[1].split('dealer:')[1]
                    }
                },
                type: "GET",
                processResults: function (data, params) {
                    let result = [];

                    categories = data;
                    if (data.services.length > 0) {
                        let aux = {
                            text: data.dealer_name, children: []
                        };

                        data.services.map((child, number) => {
                            if (child !== null) {
                                if (child.booking_type === 'car') {
                                    aux.children.push({
                                        id: child.code, text: child.name
                                    });
                                }
                            }
                        })
                        result.push(aux);

                        return {
                            results: result
                        }
                    } else {
                        return {
                            results: [{
                                text: "No hay datos para mostrar", children: []
                            }]
                        }
                    }
                }
            }
        }).prop("disabled", false).on('change', function (e) {
            create_array_for_product('category', e.target.value);

            /!*get_modalities(null, car_recogida[1].split('dealer:')[1], 'code', e.target.value, form_type_send[0].dataset.type).then(gmodality => {*!/
            get_modalities(null, car_recogida[1].split('dealer:')[1], e.target.value).then(gmodality => {

            })

            get_contract(car_recogida[1].split('dealer:')[1]).then(gcontract => {
                if (!gcontract.next) {
                    toastr.error(I18n.t('main.header.shopping_cart.selling_contract_text'), I18n.t('main.header.shopping_cart.selling_contract'));
                    return;
                }
                get_tariffs(null).then(gtariffs => {
                    if (!gtariffs.next) {
                        toastr.error(I18n.t('main.header.shopping_cart.selling_price_text'), I18n.t('main.header.shopping_cart.selling_price'));
                        return;
                    }

                })
            })

            create_array_for_product('text_category', $(e.target).select2('data')[0].text);

            categories_details(e.target.value).then(category_details => {
                let car_date_collect = $('#car_date_collect');
                let car_time_delivery = $('#car_time_delivery');
                let car_time_collect = $('#car_time_collect');
                setSessionVar('day_delay_rent', category_details.reservation_time, 'add', false).then();
                setSessionVar('day_min_rent', category_details.min_length_reservation, 'add', false).then();
                setSessionVar('day_max_rent', category_details.max_length_reservation, 'add', false).then();
                // setSessionVar('category_description', category_details.description, 'add', false);
                setSessionVar('use_same_hours', category_details.same_hours, 'add', false).then();

                if (!car_date_collect[0].value.isEmpty() && category_details.same_hours === false) {
                    car_time_delivery.prop('disabled', false);
                    car_time_delivery[0].value = '';
                    // setSessionVar('car_time_delivery', '', 'delete', false).then();
                    create_array_for_product('car_time_delivery', '', 'delete')
                } else {
                    if (!car_date_collect[0].value.isEmpty() && category_details.same_hours === true) {
                        car_time_delivery.prop('disabled', true);
                        car_time_delivery[0].value = car_time_collect[0].value;
                        // setSessionVar('car_time_delivery', car_time_collect[0].value, 'add', false).then()
                        create_array_for_product('car_time_delivery', car_time_collect[0].value);
                    }
                }

                car_date_collect.prop('disabled', false);
                car_time_collect.prop('disabled', false);
                car_time_collect.prop('readonly', true);

                flatpickr("#car_date_collect", {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    disableMobile: "true",
                    minDate: new Date().fp_incr(parseInt(category_details.reservation_time)),
                    maxDate: new Date().fp_incr(180),
                    locale: flatpick_lang
                });
            })
        })
        //    HASTA AQUI ES EL TEMPORAL

        let full_time = car_recogida[3].split('full_time:')[1];
        if (full_time === "false") {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                minTime: car_recogida[4].split('open_time:')[1] + ":00",
                maxTime: car_recogida[5].split('close_time:')[1] + ":00",
            })

            let from = car_recogida[4].split('open_time:')[1] + ":00am";
            let to = (parseInt(car_recogida[5].split("close_time:")[1]) - 12) + ":00pm";
            text_helper = I18n.t('global.main.form.work_by_hours', {from: from, to: to});
            // text_helper = "Esta oficina trabaja en el horario de 0" + recogida[4].split('open_time:')[1] + ":00am a " + (parseInt(recogida[5].split("close_time:")[1]) - 12) + ":00pm ";
        } else {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
            })

            text_helper = I18n.t('global.main.form.work_all_day');
        }

        helper.text(text_helper);
        tootltip_button[0].classList.remove('hide-tooltip');

        $(`#car_date_collect`).prop('disabled', true);
        $(`#car_time_collect`).prop('disabled', true);
    });
});

$('#car_date_collect').on('change', (e) => {
    //ESTABLECER HORAS SELECCIONABLES EN DEPENDENCIA DEL DIA QUE SE SELECCIONE
    let min_time = create_array_for_product('open_time', '', 'show');
    let max_time = create_array_for_product('close_time', '', 'show');
    let selected_date = e.target.value.split('-');
    let especial_behavior = false;
    if (`${year}-${month}-${day}` === e.target.value || (year === parseInt(selected_date[0]) && parseInt(month) === parseInt(selected_date[1]) && (parseInt(selected_date[2]) - day) === 1)) {
        especial_behavior = true;
        min_time = `${hour}:${minutes}`;
        max_time = "23:55";
    }

    if (create_array_for_product('full_time', '', 'show') === "false") {
        flatpickr(".timepicker", {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            // defaultDate: `${hour}:${minutes}`,
            altFormat: "H:i",
            time_24hr: true,
            locale: flatpick_lang,
            disableMobile: "true",
            minTime: min_time,
            maxTime: max_time,
        })
    } else {
        if (especial_behavior) {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                defaultDate: min_time,
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",
                minTime: min_time,
                maxTime: max_time,
            })
        } else {
            flatpickr(".timepicker", {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                defaultDate: min_time,
                altFormat: "H:i",
                time_24hr: true,
                locale: flatpick_lang,
                disableMobile: "true",

            })
        }
    }
    //FIN DE HORAS

    //VERIFICAR TEMPORADA
    verify_season(e.target.value).then(vs => {
        let max_date = 0;
        let min_date = 0;

        if (vs.length > 0) {
            max_date = parseInt(vs[0].max) + 1;
            min_date = parseInt(vs[0].min) + 1;
        } else {
            max_date = parseInt(sessionStorage.getItem('day_max_rent')) + 1;
            min_date = parseInt(sessionStorage.getItem('day_min_rent')) + 1;
        }
        $('#car_date_delivery').prop('disabled', false);
        flatpickr("#car_date_delivery", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disableMobile: "true",
            disable: date_disabled,
            minDate: new Date(e.target.value).fp_incr(min_date),
            maxDate: new Date(e.target.value).fp_incr(max_date),
            locale: flatpick_lang
        });

        if (sessionStorage.getItem('use_same_hours') !== 'true') {
            $('#car_time_delivery').prop('disabled', false);
        }

    });
})
$('#car_time_collect').on('change', (e) => {
    if (sessionStorage.getItem('use_same_hours') === 'true') {
        let car_time_delivery = $('#car_time_delivery');
        car_time_delivery[0].value = e.target.value;
        // setSessionVar('time_delivery', e.target.value, 'add', false).then()
        create_array_for_product('car_time_delivery', e.target.value);
    }
})
/!* Car new product FINN *!/*/
